"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getPersonaByEmail_1 = require("./../../util/getPersonaByEmail");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('fetchAndRefreshPersona')(function fetchAndRefreshPersona(currentPersonaId, currentPersonaEmail, currentDisplayName) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, persona, favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = owa_mail_favorites_store_1.getStore();
                    return [4 /*yield*/, getPersonaByEmail_1.default(currentPersonaEmail, currentDisplayName)];
                case 1:
                    persona = _a.sent();
                    favoritePersona = state.favoritesPersonaNodes.get(currentPersonaId);
                    if (favoritePersona) {
                        newDisplayName = persona.DisplayName;
                        newMainEmailAddress = persona.EmailAddress.EmailAddress;
                        newAllEmailAddresses = persona.EmailAddresses.map(function (email) { return email.EmailAddress; });
                        if (favoritePersona.displayName !== newDisplayName ||
                            favoritePersona.mainEmailAddress !== newMainEmailAddress ||
                            !hasSameItems(favoritePersona.allEmailAddresses, newAllEmailAddresses)) {
                            state.haveFavoritePersonasChanged = true;
                            updatePersona(favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
// This is extracted to separate function due to bug in Satchel which occurs in tests:
// [mobx] Invariant failed: It is not allowed to create or change state outside an `action` when MobX is in strict mode.
var updatePersona = legacy_1.action('updatePersona')(function updatePersona(favoritePersona, newDisplayName, newMainEmailAddress, newAllEmailAddresses) {
    favoritePersona.displayName = newDisplayName;
    favoritePersona.mainEmailAddress = newMainEmailAddress;
    favoritePersona.allEmailAddresses = newAllEmailAddresses;
});
function hasSameItems(left, right) {
    return (left &&
        right &&
        left.length === right.length &&
        left.every(function (element) { return right.includes(element); }));
}
//# sourceMappingURL=fetchAndRefreshPersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/people/fetchAndRefreshPersona.js
// module id = 4650
// module chunks = 14